import { Fragment } from "react";

import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import Separator from "components/DesignComponents/Separator";
import { useRoutes } from "components/Routes/hooks/useRoutes";
import { getEnvironment } from "shared/functions";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import LinkItem from "./LinkItem";
import TctWeb from "./TctWeb";

const Navigation = () => {
    const { gray200 } = colors;

    const { routes } = useRoutes();
    const { toMd } = useMediaQueries();
    const { isFotaGlobalEnv } = getEnvironment();

    return (
        <nav>
            <ul
                css={css({
                    "li + li": {
                        marginTop: "8px"
                    }
                })}
            >
                {routes.map(({ navigation, isRestricted, path }) => {
                    if (navigation && !isRestricted) {
                        const { name, icon, hasSeparator } = navigation;

                        return (
                            <Fragment key={name}>
                                {hasSeparator && (
                                    <Separator
                                        isListSeparator
                                        css={css({
                                            background: gray200
                                        })}
                                    />
                                )}

                                <LinkItem name={name} icon={icon} link={path} />
                            </Fragment>
                        );
                    }

                    return null;
                })}

                {(isFotaGlobalEnv || toMd) && (
                    <Separator
                        isListSeparator
                        css={css({
                            background: gray200
                        })}
                    />
                )}

                {isFotaGlobalEnv && <TctWeb />}
            </ul>
        </nav>
    );
};

export default Navigation;
